export default () => {
    // Early Exit if module not present
    if ($('.location-page__main__products').length === 0) {
        return;
    }

    $('.location-page__main__products__tabs__tab').on('click', function() {
       switchTabs($(this));
    });

    // Switch tabs and show and hide different product types
    function switchTabs($this) {
        const selectedProduct = $this.data('product'),
            tabActiveClassName = 'location-page__main__products__tabs__tab-active',
            productActiveClassName = 'location-page__main__products__product__content-active',
            productContent = $(`.location-page__main__products__product__content[data-product='${selectedProduct}']`);

        if (!productContent.hasClass(productActiveClassName)) {
            $(`.${tabActiveClassName}`).removeClass(tabActiveClassName);
            $(`.${productActiveClassName}`).removeClass(productActiveClassName);
            $this.addClass(tabActiveClassName);
            productContent.addClass(productActiveClassName);
        }
    }
}